import { GetContactsQuery } from '@/shared/types/api'

export const contactsQueryToString = (query: GetContactsQuery): string => {
  let string = `Page=${query.Page}&Size=${query.Size}`

  if (query.FilterLogicOperator) {
    string += `&FilterLogicOperator=${query.FilterLogicOperator}`
  }

  if (query.Direction) {
    string += `&Direction=${query.Direction}`
  }

  if (query.Property) {
    string += `&Property=${query.Property}`
  }

  if (query.SearchText) {
    string += `&SearchText=${query.SearchText}`
  }

  if (query.groupId) {
    string += `&groupId=${query.groupId}`
  }

  if (query.groupType) {
    string += `&groupType=${query.groupType}`
  }

  if (query.SortBy) {
    string += `&SortBy=${query.SortBy}`
  }

  if (query.Order) {
    string += `&Order=${query.Order}`
  }

  if (query.contactType) {
    string += `&contactType=${query.contactType}`
  }

  if (query.Filters) {
    query.Filters.forEach((f, i) => {
      f.AvailableOperations.forEach((o, j) => {
        string += `&Filters[${i}].AvailableOperations[${j}]=${o}`
      })
      string += `&Filters[${i}].AvailableValues=${f.AvailableValues}`
      string += `&Filters[${i}].PropertyName=${f.PropertyName}`
      string += `&Filters[${i}].TypeFilter=${f.TypeFilter}`
    })
  }

  return string
}
